import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = new Map();

const fetchDl = (token) => {
  const hit = cache.get(token);
  if (hit && Date.now() - hit.at < 8 * 60 * 1000) return hit.p;
  const p = axios.post(`${API}/auth/download-token`, {}, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data.token).catch(() => { cache.delete(token); return ""; });
  cache.set(token, { p, at: Date.now() });
  return p;
};

// Short-lived download token for links (?token=); refreshed before it expires.
export const useDl = (token) => {
  const [dl, setDl] = useState("");
  useEffect(() => {
    if (!token) return undefined;
    let alive = true;
    const run = () => fetchDl(token).then((v) => alive && setDl(v));
    run();
    const id = setInterval(run, 8 * 60 * 1000 + 1000);
    return () => { alive = false; clearInterval(id); };
  }, [token]);
  return dl;
};
